export class DivisaoHonrariosDTO {
    DivisaoID: number;
    ProcessoId: number;
    Ficha: string;
    NomeFantasiaCliente: string;
    ValorTotal: string;
    // NumeroParcelas: number;
    ValorRecebido: string;
    ValorPagoTotal: string;

}

export class DivisaoHonorariosFiltros {
    NumeroFicha: string;
    ParticipanteId: number;
    DemonstrativoDeResultadoId: number;
    VencimentoInicial: string;
    DataInicial: string;
    DataFinal: string;
    Pagina: number;
}